import { useQuery } from "react-query";
import { getCarrierPhoneType } from "../../../../actions/CarrierAgreementMgmt/Carrier";

export const useGetCarrierPhoneType = () => {
  return useQuery("GetCarrierPhoneType", getCarrierPhoneType, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
